import React from 'react';
import { AiFillFacebook, AiFillGoogleCircle, AiFillTwitterCircle } from 'react-icons/ai';
import Footer from '../components/Footer';
import Header from '../components/Header';

const ForgotPassword = () => {
    const emailPlaceholder = "Enter your email address";

    const handleSubmit = (e) => {
        e.preventDefault();
        // Implémentez ici la logique pour envoyer un email de réinitialisation de mot de passe
        console.log("Password reset email sent.");
    };

    return (
        <div>
            <Header />
            <div className="page-heading header-text">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Forgot Password</h1>
                            <span>Enter your email to reset your password</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="vh-100 d-flex justify-content-center align-items-center">
            <div className="callback-form" style={{ maxWidth: '900px', marginTop: '20px', marginBottom:'20px'}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="contact-form">
                                    <form onSubmit={handleSubmit} id="forgot-password">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="email" className="mb-1">Email address</label>
                                                    <input name="email" type="email" className="form-control" id="email" placeholder={emailPlaceholder} required />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 d-flex justify-content-center align-items-center mb-3">
                                                <button type="submit" className="border-button">Reset Password</button>
                                            </div>
                                        </div>
 <div className="col-lg-12 mb-3">
                                                <p className="mt-3 mb-2 text-center">Or reset password with:</p>
                                                <div className="social-login">
                                                    <button type="button" className="btn btn-primary rounded-circle p-2 mr-2">
                                                        <AiFillGoogleCircle style={{ fontSize: '24px', margin: '0' }} />
                                                    </button>
                                                    <button type="button" className="btn btn-primary rounded-circle p-2 mr-2">
                                                        <AiFillFacebook style={{ fontSize: '24px', margin: '0' }} />
                                                    </button>
                                                    <button type="button" className="btn btn-primary rounded-circle p-2">
                                                        <AiFillTwitterCircle style={{ fontSize: '24px', margin: '0' }} />
                                                    </button>
                                                </div>
                                            </div>

                                    </form>
 <div className="text-center mt-3">
                                            <p>Remember Password? <a href="/Login" className="text-decoration-none">Login</a></p>
                                        </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ForgotPassword;

